// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-to-generate-certificate:hover {
    background-color: #19a7ce;
    color: #fff;
  }`, "",{"version":3,"sources":["webpack://./src/components/GenerateCertificate/generateCertificate.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,WAAW;EACb","sourcesContent":[".card-to-generate-certificate:hover {\n    background-color: #19a7ce;\n    color: #fff;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
